<template>
  <div class="partner-panel"
       :class="{_open: showPanelInfo}">
    <div class="partner-panel__user">
      <picture v-if="userProfile.avatar"
               class="partner-panel__candidate-img">
        <img :src="userProfile.avatar"
             alt="User"/>
      </picture>
      <div v-else
           class="partner-panel__candidate-img  _placeholder">
        {{ $tPartners('You') }}
      </div>
      <div class="partner-panel__candidate-name">
        {{ userProfile.fullname }}
      </div>
    </div>
    <div class="partner-panel__info">
      <div class="partner-panel__info-item">
        <small>{{ $tPartners('partner_from') }}</small>
        <b>{{ currentPartner.register_date }}</b>
      </div>
      <div class="partner-panel__info-item">
        <small>{{ $tPartners('invited_partners') }}</small>
        <b>{{ currentPartner.all_network_jobseeker_count }}</b>
      </div>
      <div class="partner-panel__info-item">
        <small>{{ $tPartners('agents_in_network') }}</small>
        <b>{{ currentPartner.all_network_partners_count }}</b>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PartnerPanel',
    props: {
      currentPartner: {
        type: Object
      }
    },
    data() {
      return {
        showPanelInfo: false
      }
    },
    computed: {
      userProfile() {
        return this.$store.state.user.profile
      },
    },
    methods: {
      onTogglePanelInfo() {
        this.showPanelInfo = !this.showPanelInfo
      },
      getAbbr(first, second) {
        return (first && first[0] || '-') + (second && second[0] || '-')
      }
    }
  }
</script>

<style>

</style>
